import PopNotifications from './PopNotifications.component';

export default PopNotifications;
